export const keys = {
  AGO: "AGO",
  ADD: "ADD",
  ALL: "ALL",
  APPOINTMENT_DETAILS: "APPOINTMENT_DETAILS",
  APPOINTMENT_DETAILS_INTRO: "APPOINTMENT_DETAILS_INTRO",
  APPOINTMENTS: "APPOINTMENTS",
  ARRIVAL: "ARRIVAL",
  AUTO_REFRESH: "AUTO_REFRESH",
  AUTO_REFRESH_TEXT: "AUTO_REFRESH_TEXT",
  AIR_SLEEVES: "AIR_SLEEVES",
  BAG: "BAG",
  BILLING: "BILLING",
  BOBTAIL: "BOBTAIL",
  CANCEL: "CANCEL",
  CARTS: "CARTS",
  CLEAR: "CLEAR",
  CONSUMABLES: "CONSUMABLES",
  CUSTOMER_PACKAGE: "CUSTOMER_PACKAGE",
  CUSTOMER_RETURN: "CUSTOMER_RETURN",
  DISASTER_RELIEF: "DISASTER_RELIEF",
  DONATION: "DONATION",
  EMPTY_BAGS: "EMPTY_BAGS",
  EMPTY_CARTS: "EMPTY_CARTS",
  EMPTY_PODS: "EMPTY_PODS",
  EMPTY_SKIDS: "EMPTY_SKIDS",
  EMPTY_TOTES: "EMPTY_TOTES",
  EMPTY_ULD: "EMPTY_ULD",
  FULL_PODS: "FULL_PODS",
  GARBAGE: "GARBAGE",
  GAYLORDS: "GAYLORDS",
  INBOUND_INVENTORY: "INBOUND_INVENTORY",
  MAINTENANCE: "MAINTENANCE",
  NON_INVENTORY: "NON_INVENTORY",
  PALLETS: "PALLETS",
  PALLET_SLEEVES: "PALLET_SLEEVES",
  RECOVERY: "RECOVERY",
  REDIRECT: "REDIRECT",
  RETURN: "RETURN",
  REUSABLES: "REUSABLES",
  SHUTTLE: "SHUTTLE",
  SKIDS: "SKIDS",
  SMALL_PARCEL: "SMALL_PARCEL",
  TOMY: "TOMY",
  TRAILER_HAND_OFF: "TRAILER_HAND_OFF",
  TOTES: "TOTES",
  UNIVERSAL_PALLET: "UNIVERSAL_PALLET",
  UNIVERSAL_PLASTIC_PALLET: "UNIVERSAL_PLASTIC_PALLET",
  UPP: "UPP",
  VENDOR_RETURN: "VENDOR_RETURN",
  NO_LOAD_TYPE: "NO_LOAD_TYPE",
  NO_LOAD_SUB_TYPE: "NO_LOAD_SUB_TYPE",
  CONTENT_TAGS: "CONTENT_TAGS",
  CONTENT_TAGS_EMPTY_STATUS_TOOLTIP: "CONTENT_TAGS_EMPTY_STATUS_TOOLTIP",
  DEPARTURE: "DEPARTURE",
  DETAILS: "DETAILS",
  DEVICE: "DEVICE",
  DRIVER_READ: "DRIVER_READ",
  DURATION: "DURATION",
  DWELL_TIME: "DWELL_TIME",
  EDIT_CONTENT_TAGS: "EDIT_CONTENT_TAGS",
  EDIT_EMPTY_STATUS: "EDIT_EMPTY_STATUS",
  EDIT_NOTES: "EDIT_NOTES",
  EMPTY: "EMPTY",
  EMPTY_STATUS: "EMPTY_STATUS",
  ENTER_NOTES: "ENTER_NOTES",
  EQUIPMENT: "EQUIPMENT",
  EQUIPMENT_REPORT_FEATURE_FLAG_RETRIEVAL_ERROR_TEXT:
    "EQUIPMENT_REPORT_FEATURE_FLAG_RETRIEVAL_ERROR_TEXT",
  EQUIPMENT_REPORT_NOT_ENABLED: "EQUIPMENT_REPORT_NOT_ENABLED",
  EQUIPMENT_REPORT_RETRIEVAL_ERROR_TEXT: "EQUIPMENT_REPORT_RETRIEVAL_ERROR_TEXT",
  EQUIPMENT_TYPE: "EQUIPMENT_TYPE",
  ERROR: "ERROR",
  FALSE: "FALSE",
  FROM_1_TO_6_HR: "FROM_1_TO_6_HR",
  FROM_6_TO_24_HR: "FROM_6_TO_24_HR",
  FROM_24_HR: "FROM_24_HR",
  FROM_30_TO_60_MIN: "FROM_30_TO_60_MIN",
  HELP: "HELP",
  IDENTIFIER: "IDENTIFIER",
  INBOUND: "INBOUND",
  IYI_STATUS: "IYI_STATUS",
  LANGUAGE: "LANGUAGE",
  LATE_FOR: "LATE_FOR",
  LATEST_MESSAGE: "LATEST_MESSAGE",
  LESS_THAN_30_MIN: "LESS_THAN_30_MIN",
  LOAD_CONDITION: "LOAD_CONDITION",
  LOAD_ID: "LOAD_ID",
  LOAD_STATUS: "LOAD_STATUS",
  LOAD_SUB_TYPE: "LOAD_SUB_TYPE",
  LOAD_TYPE: "LOAD_TYPE",
  LOCATIONS: "LOCATIONS",
  LOCATION: "LOCATION",
  MESSAGE_SENT: "MESSAGE_SENT",
  MOVE_EQUIPMENT: "MOVE_EQUIPMENT",
  NEXT_STATUS: "NEXT_STATUS",
  NO: "NO",
  NOTES: "NOTES",
  NO_RESULTS: "NO_RESULTS",
  NO_TAGS_SAVED_TEXT: "NO_TAGS_SAVED_TEXT",
  NON_EMPTY: "NON_EMPTY",
  NOT_APPLICABLE: "NOT_APPLICABLE",
  OUTBOUND: "OUTBOUND",
  PAGINATE: "PAGINATE",
  PROGRESS: "PROGRESS",
  PROGRESS_ERROR_TOOLTIP: "PROGRESS_ERROR_TOOLTIP",
  PURPOSE: "PURPOSE",
  REFRESH: "REFRESH",
  ROWS: "ROWS",
  SAVE: "SAVE",
  SCAC_CODE: "SCAC_CODE",
  SEARCH: "SEARCH",
  SELECT_ACCOUNT: "SELECT_ACCOUNT",
  SHIPPER_ACCOUNT: "SHIPPER_ACCOUNT",
  SHOW_ALL: "SHOW_ALL",
  STATUS: "STATUS",
  SUMMARY: "SUMMARY",
  TAGS_TO_BE_SAVED: "TAGS_TO_BE_SAVED",
  TYPE: "TYPE",
  TRUE: "TRUE",
  VIEW: "VIEW",
  WHAT_IS_NEW: "WHAT_IS_NEW",
  WRANGLING_REPORT_FEATURE_FLAG_RETRIEVAL_ERROR_TEXT:
    "WRANGLING_REPORT_FEATURE_FLAG_RETRIEVAL_ERROR_TEXT",
  WRANGLING_REPORT_NOT_ENABLED: "WRANGLING_REPORT_NOT_ENABLED",
  WRANGLING_REPORT_RETRIEVAL_ERROR_TEXT: "WRANGLING_REPORT_RETRIEVAL_ERROR_TEXT",
  YES: "YES",
  ROUTE_ERROR_CHUNK: "ROUTE_ERROR_CHUNK",
  ROUTE_ERROR_COPY_LOGS: "ROUTE_ERROR_COPY_LOGS",
  ROUTE_ERROR_REASON: "ROUTE_ERROR_REASON",
  ROUTE_ERROR_GENERIC: "ROUTE_ERROR_GENERIC",
  RELOAD_PAGE: "RELOAD_PAGE",
  EVENT_REPORT_TITLE: "EVENT_REPORT_TITLE",
  EVENT_REPORT_VISIT_OLD_VIEW: "EVENT_REPORT_VISIT_OLD_VIEW",
  EVENT_REPORT_SEARCH: "EVENT_REPORT_SEARCH",
  EVENT_REPORT_SEARCH_HISTORY: "EVENT_REPORT_SEARCH_HISTORY",
  EVENT_REPORT_SEARCH_HISTORY_EMPTY: "EVENT_REPORT_SEARCH_HISTORY_EMPTY",
  EVENT_REPORT_SEARCH_HISTORY_SAVED_AT: "EVENT_REPORT_SEARCH_HISTORY_SAVED_AT",
  EVENT_REPORT_SEARCH_HISTORY_USE: "EVENT_REPORT_SEARCH_HISTORY_USE",
  EVENT_REPORT_SEARCH_HISTORY_USE_QUERY: "EVENT_REPORT_SEARCH_HISTORY_USE_QUERY",
  EVENT_REPORT_MULTI_VALUE_INFO: "EVENT_REPORT_MULTI_VALUE_INFO",
  EVENT_REPORT_MULTI_VALUE_INFO_ARIA: "EVENT_REPORT_MULTI_VALUE_INFO_ARIA",
  EVENT_REPORT_LICENSE_PLATES: "EVENT_REPORT_LICENSE_PLATES",
  EVENT_REPORT_VEHICLE_NUMBERS: "EVENT_REPORT_VEHICLE_NUMBERS",
  EVENT_REPORT_LOAD_IDS: "EVENT_REPORT_LOAD_IDS",
  EVENT_REPORT_REMOVE_IDENTIFIER: "EVENT_REPORT_REMOVE_IDENTIFIER",
  EVENT_REPORT_ROWS_PER_PAGE: "EVENT_REPORT_ROWS_PER_PAGE",
  EVENT_REPORT_MERGE_STATUS: "EVENT_REPORT_MERGE_STATUS",
  EVENT_REPORT_MERGE_WARNING: "EVENT_REPORT_MERGE_WARNING",
  EVENT_REPORT_COPY_GATE_OPERATION_ID: "EVENT_REPORT_COPY_GATE_OPERATION_ID",
  EVENT_REPORT_COPY_CONNECT_CONTACT_ID: "EVENT_REPORT_COPY_CONNECT_CONTACT_ID",
  EVENT_REPORT_COPY_FIELD: "EVENT_REPORT_COPY_FIELD",
  EVENT_REPORT_REQUEST_ID: "EVENT_REPORT_REQUEST_ID",
  EVENT_REPORT_COPY_REQUEST_ID_HINT: "EVENT_REPORT_COPY_REQUEST_ID_HINT",
  EVENT_REPORT_REQUEST_ID_COPIED: "EVENT_REPORT_REQUEST_ID_COPIED",
  EVENT_REPORT_REQUEST_ID_COPY_FAILED: "EVENT_REPORT_REQUEST_ID_COPY_FAILED",
  EVENT_REPORT_TIMEZONE: "EVENT_REPORT_TIMEZONE",
  EVENT_REPORT_YARD: "EVENT_REPORT_YARD",
  EVENT_REPORT_LOCATION: "EVENT_REPORT_LOCATION",
  EVENT_REPORT_EVENT: "EVENT_REPORT_EVENT",
  EVENT_REPORT_EVENT_TYPE: "EVENT_REPORT_EVENT_TYPE",
  EVENT_REPORT_ANY_EVENT: "EVENT_REPORT_ANY_EVENT",
  EVENT_REPORT_HIGH_RISK_CHECKOUT_ALERT: "EVENT_REPORT_HIGH_RISK_CHECKOUT_ALERT",
  EVENT_REPORT_NO_EXIT_ALERT: "EVENT_REPORT_NO_EXIT_ALERT",
  EVENT_REPORT_FROM_DATE: "EVENT_REPORT_FROM_DATE",
  EVENT_REPORT_TO_DATE: "EVENT_REPORT_TO_DATE",
  EVENT_REPORT_USER_ID: "EVENT_REPORT_USER_ID",
  EVENT_REPORT_SYSTEM: "EVENT_REPORT_SYSTEM",
  EVENT_REPORT_LICENSE_PLATE: "EVENT_REPORT_LICENSE_PLATE",
  EVENT_REPORT_OWNER: "EVENT_REPORT_OWNER",
  EVENT_REPORT_VEHICLE_TYPE: "EVENT_REPORT_VEHICLE_TYPE",
  EVENT_REPORT_VEHICLE_NUMBER: "EVENT_REPORT_VEHICLE_NUMBER",
  EVENT_REPORT_YARD_ASSET_ID: "EVENT_REPORT_YARD_ASSET_ID",
  EVENT_REPORT_YARD_ASSET_ID_VALUE: "EVENT_REPORT_YARD_ASSET_ID_VALUE",
  EVENT_REPORT_SEAL: "EVENT_REPORT_SEAL",
  EVENT_REPORT_COMMENT: "EVENT_REPORT_COMMENT",
  EVENT_REPORT_ADD_NOTE: "EVENT_REPORT_ADD_NOTE",
  EVENT_REPORT_NOTE_CHARACTERS_REMAINING: "EVENT_REPORT_NOTE_CHARACTERS_REMAINING",
  EVENT_REPORT_NOTE_SAVE_FAILED: "EVENT_REPORT_NOTE_SAVE_FAILED",
  EVENT_REPORT_VISIT_REASON: "EVENT_REPORT_VISIT_REASON",
  EVENT_REPORT_ANY_VISIT_REASON: "EVENT_REPORT_ANY_VISIT_REASON",
  EVENT_REPORT_LOAD_ID_TYPE: "EVENT_REPORT_LOAD_ID_TYPE",
  EVENT_REPORT_ANY_LOAD_TYPE: "EVENT_REPORT_ANY_LOAD_TYPE",
  EVENT_REPORT_LOAD_ID: "EVENT_REPORT_LOAD_ID",
  EVENT_REPORT_EXPORT: "EVENT_REPORT_EXPORT",
  EVENT_REPORT_EXPORTING: "EVENT_REPORT_EXPORTING",
  EVENT_REPORT_INDEXED_FILTER_REQUIRED: "EVENT_REPORT_INDEXED_FILTER_REQUIRED",
  EVENT_REPORT_INVALID_DATE_RANGE: "EVENT_REPORT_INVALID_DATE_RANGE",
  EVENT_REPORT_LOCATION_REQUIRES_YARD: "EVENT_REPORT_LOCATION_REQUIRES_YARD",
  EVENT_REPORT_CSV_LIMIT_WARNING: "EVENT_REPORT_CSV_LIMIT_WARNING",
  EVENT_REPORT_LOAD_ERROR: "EVENT_REPORT_LOAD_ERROR",
  EVENT_REPORT_RESULT_COUNT: "EVENT_REPORT_RESULT_COUNT",
  EVENT_REPORT_TABLE_TEXT_SIZE: "EVENT_REPORT_TABLE_TEXT_SIZE",
  EVENT_REPORT_TABLE_TEXT_SIZE_SMALL: "EVENT_REPORT_TABLE_TEXT_SIZE_SMALL",
  EVENT_REPORT_TABLE_TEXT_SIZE_MEDIUM: "EVENT_REPORT_TABLE_TEXT_SIZE_MEDIUM",
  EVENT_REPORT_TABLE_TEXT_SIZE_LARGE: "EVENT_REPORT_TABLE_TEXT_SIZE_LARGE",
  EVENT_REPORT_RESIZE_COLUMN: "EVENT_REPORT_RESIZE_COLUMN",
  EVENT_REPORT_PAGINATION: "EVENT_REPORT_PAGINATION",
  EVENT_REPORT_YARD_LOCATION: "EVENT_REPORT_YARD_LOCATION",
  EVENT_REPORT_DATE: "EVENT_REPORT_DATE",
  EVENT_REPORT_USER_SYSTEM: "EVENT_REPORT_USER_SYSTEM",
  EVENT_REPORT_VEHICLE: "EVENT_REPORT_VEHICLE",
  EVENT_REPORT_EQUIPMENT: "EVENT_REPORT_EQUIPMENT",
  EVENT_REPORT_SEALS: "EVENT_REPORT_SEALS",
  EVENT_REPORT_CARRIER: "EVENT_REPORT_CARRIER",
  EVENT_REPORT_LOAD: "EVENT_REPORT_LOAD",
  EVENT_REPORT_DETAIL_TITLE: "EVENT_REPORT_DETAIL_TITLE",
  EVENT_REPORT_DETAIL_NOT_FOUND: "EVENT_REPORT_DETAIL_NOT_FOUND",
  EVENT_REPORT_BACK: "EVENT_REPORT_BACK",
  EVENT_REPORT_IMAGES_UNAVAILABLE_BEFORE: "EVENT_REPORT_IMAGES_UNAVAILABLE_BEFORE",
  EVENT_REPORT_GATE: "EVENT_REPORT_GATE",
  EVENT_REPORT_LANE: "EVENT_REPORT_LANE",
  EVENT_REPORT_EXPECTED_SEAL: "EVENT_REPORT_EXPECTED_SEAL",
  EVENT_REPORT_ACTUAL_SEAL: "EVENT_REPORT_ACTUAL_SEAL",
  EVENT_REPORT_EXPECTED: "EVENT_REPORT_EXPECTED",
  EVENT_REPORT_ACTUAL: "EVENT_REPORT_ACTUAL",
  EVENT_REPORT_LOCATION_RECOMMENDATION: "EVENT_REPORT_LOCATION_RECOMMENDATION",
  EVENT_REPORT_GATE_IMAGES: "EVENT_REPORT_GATE_IMAGES",
  EVENT_REPORT_GATE_OPERATION_DETAILS: "EVENT_REPORT_GATE_OPERATION_DETAILS",
  EVENT_REPORT_GATE_OPERATION_TYPE: "EVENT_REPORT_GATE_OPERATION_TYPE",
  EVENT_REPORT_ZERO_CLICK: "EVENT_REPORT_ZERO_CLICK",
  EVENT_REPORT_GATE_OPERATION_ID: "EVENT_REPORT_GATE_OPERATION_ID",
  EVENT_REPORT_CONNECT_CONTACT_ID: "EVENT_REPORT_CONNECT_CONTACT_ID",
  EVENT_REPORT_IMAGE_PREVIEW: "EVENT_REPORT_IMAGE_PREVIEW",
  EVENT_REPORT_CLOSE: "EVENT_REPORT_CLOSE",
  EVENT_REPORT_RELATED_ACTIVITY: "EVENT_REPORT_RELATED_ACTIVITY",
  EVENT_REPORT_SEARCH_CONTEXT: "EVENT_REPORT_SEARCH_CONTEXT",
  EVENT_REPORT_HISTORICAL_ACTIVITY: "EVENT_REPORT_HISTORICAL_ACTIVITY",
  EVENT_REPORT_CURRENT_CONTEXT: "EVENT_REPORT_CURRENT_CONTEXT",
  EVENT_REPORT_VIEW_DETAILS: "EVENT_REPORT_VIEW_DETAILS",
  EVENT_REPORT_VIEW_VISIT_HISTORY: "EVENT_REPORT_VIEW_VISIT_HISTORY",
  EVENT_REPORT_VIEW_LOAD_HISTORY: "EVENT_REPORT_VIEW_LOAD_HISTORY",
  EVENT_REPORT_LOCATION_PLAN: "EVENT_REPORT_LOCATION_PLAN",
  EVENT_REPORT_VIEW_EQUIPMENT_HISTORY: "EVENT_REPORT_VIEW_EQUIPMENT_HISTORY",
  EVENT_REPORT_OPEN_YARD_CONTROL: "EVENT_REPORT_OPEN_YARD_CONTROL",
  EVENT_REPORT_OPEN_AUTO_DOCK: "EVENT_REPORT_OPEN_AUTO_DOCK",
  EVENT_REPORT_OPEN_HOSTLER_POOL: "EVENT_REPORT_OPEN_HOSTLER_POOL",
  EVENT_REPORT_CURRENT_CONTEXT_NOTE: "EVENT_REPORT_CURRENT_CONTEXT_NOTE",
  EVENT_REPORT_EXACT_RELATIONSHIP: "EVENT_REPORT_EXACT_RELATIONSHIP",
  EVENT_REPORT_CONTEXT_SEARCH: "EVENT_REPORT_CONTEXT_SEARCH",
  EVENT_REPORT_CURRENT_OPERATIONAL_CONTEXT: "EVENT_REPORT_CURRENT_OPERATIONAL_CONTEXT",
  EVENT_REPORT_GATE_EVENT_DETAILS: "EVENT_REPORT_GATE_EVENT_DETAILS",
  EVENT_REPORT_VISIT_HISTORY: "EVENT_REPORT_VISIT_HISTORY",
  EVENT_REPORT_LOAD_HISTORY: "EVENT_REPORT_LOAD_HISTORY",
  EVENT_REPORT_EQUIPMENT_HISTORY: "EVENT_REPORT_EQUIPMENT_HISTORY",
  EVENT_REPORT_YARD_CONTROL_CONTEXT: "EVENT_REPORT_YARD_CONTROL_CONTEXT",
  EVENT_REPORT_AUTO_DOCK_CONTEXT: "EVENT_REPORT_AUTO_DOCK_CONTEXT",
  EVENT_REPORT_HOSTLER_POOL_CONTEXT: "EVENT_REPORT_HOSTLER_POOL_CONTEXT",
  EVENT_REPORT_LOCATION_CONTEXT: "EVENT_REPORT_LOCATION_CONTEXT",
  EVENT_REPORT_RELATED_CONTEXT_SUMMARY: "EVENT_REPORT_RELATED_CONTEXT_SUMMARY",
  EVENT_REPORT_RELATED_CURRENT_SUMMARY: "EVENT_REPORT_RELATED_CURRENT_SUMMARY",
  EVENT_REPORT_RELATED_EVENTS_IN_PAGE: "EVENT_REPORT_RELATED_EVENTS_IN_PAGE",
  EVENT_REPORT_RELATED_EVENTS_IN_QUERY: "EVENT_REPORT_RELATED_EVENTS_IN_QUERY",
  EVENT_REPORT_RELATED_PAGE_NOTE: "EVENT_REPORT_RELATED_PAGE_NOTE",
  EVENT_REPORT_RELATED_QUERY: "EVENT_REPORT_RELATED_QUERY",
  EVENT_REPORT_RELATED_QUERY_HINT: "EVENT_REPORT_RELATED_QUERY_HINT",
  EVENT_REPORT_RELATED_DATE_RANGE: "EVENT_REPORT_RELATED_DATE_RANGE",
  EVENT_REPORT_RELATED_RANGE_LIMIT: "EVENT_REPORT_RELATED_RANGE_LIMIT",
  EVENT_REPORT_RELATED_QUICK_RANGE: "EVENT_REPORT_RELATED_QUICK_RANGE",
  EVENT_REPORT_RELATED_RANGE_4_HOURS: "EVENT_REPORT_RELATED_RANGE_4_HOURS",
  EVENT_REPORT_RELATED_RANGE_8_HOURS: "EVENT_REPORT_RELATED_RANGE_8_HOURS",
  EVENT_REPORT_RELATED_RANGE_1_DAY: "EVENT_REPORT_RELATED_RANGE_1_DAY",
  EVENT_REPORT_RELATED_RANGE_3_DAYS: "EVENT_REPORT_RELATED_RANGE_3_DAYS",
  EVENT_REPORT_RELATED_FETCH: "EVENT_REPORT_RELATED_FETCH",
  EVENT_REPORT_RELATED_LOADING: "EVENT_REPORT_RELATED_LOADING",
  EVENT_REPORT_RELATED_HISTORY_LOADED: "EVENT_REPORT_RELATED_HISTORY_LOADED",
  EVENT_REPORT_RELATED_LOAD_FAILED: "EVENT_REPORT_RELATED_LOAD_FAILED",
  EVENT_REPORT_RELATED_INCOMPLETE: "EVENT_REPORT_RELATED_INCOMPLETE",
  EVENT_REPORT_RELATED_RANGE_INVALID: "EVENT_REPORT_RELATED_RANGE_INVALID",
  EVENT_REPORT_RELATED_SEARCH_SCOPE: "EVENT_REPORT_RELATED_SEARCH_SCOPE",
  EVENT_REPORT_RELATED_THIS_BUILDING: "EVENT_REPORT_RELATED_THIS_BUILDING",
  EVENT_REPORT_RELATED_ALL_BUILDINGS: "EVENT_REPORT_RELATED_ALL_BUILDINGS",
  EVENT_REPORT_RELATED_ALL_BUILDINGS_WARNING: "EVENT_REPORT_RELATED_ALL_BUILDINGS_WARNING",
  EVENT_REPORT_RELATED_EVENTS: "EVENT_REPORT_RELATED_EVENTS",
  EVENT_REPORT_RELATED_EMPTY: "EVENT_REPORT_RELATED_EMPTY",
  EVENT_REPORT_RELATED_EMPTY_HINT: "EVENT_REPORT_RELATED_EMPTY_HINT",
  EVENT_REPORT_RELATED_TECHNICAL_DETAILS: "EVENT_REPORT_RELATED_TECHNICAL_DETAILS",
  EVENT_REPORT_RELATED_OPEN_FULL_HISTORY: "EVENT_REPORT_RELATED_OPEN_FULL_HISTORY",
  EVENT_REPORT_DESTINATION: "EVENT_REPORT_DESTINATION",
  EVENT_REPORT_COPY_LINK: "EVENT_REPORT_COPY_LINK",
  EVENT_REPORT_LINK_COPIED: "EVENT_REPORT_LINK_COPIED",
  EVENT_REPORT_VISIT_ID: "EVENT_REPORT_VISIT_ID",
  EVENT_REPORT_TIMELINE_HOSTLER_MOVING: "EVENT_REPORT_TIMELINE_HOSTLER_MOVING",
  EVENT_REPORT_TIMELINE_IB_DOCKING: "EVENT_REPORT_TIMELINE_IB_DOCKING",
  EVENT_REPORT_TIMELINE_OB_DOCKING: "EVENT_REPORT_TIMELINE_OB_DOCKING",
  EVENT_REPORT_TIMELINE_SEAL_VALIDATION: "EVENT_REPORT_TIMELINE_SEAL_VALIDATION",
  EVENT_REPORT_TIMELINE_SEAL_CUTTING: "EVENT_REPORT_TIMELINE_SEAL_CUTTING",
  EVENT_REPORT_TIMELINE_NO_EXIT_ALERT: "EVENT_REPORT_TIMELINE_NO_EXIT_ALERT",
  EVENT_REPORT_TIMELINE_DERIVED_INTERVAL: "EVENT_REPORT_TIMELINE_DERIVED_INTERVAL",
  EVENT_REPORT_TIMELINE_LANE_DOCK: "EVENT_REPORT_TIMELINE_LANE_DOCK",
  EVENT_REPORT_TIMELINE_LANE_ALERT: "EVENT_REPORT_TIMELINE_LANE_ALERT",
  EVENT_REPORT_TIMELINE_LANE_YARD: "EVENT_REPORT_TIMELINE_LANE_YARD",
  EVENT_REPORT_TIMELINE_TDR_DOCK: "EVENT_REPORT_TIMELINE_TDR_DOCK",
  EVENT_REPORT_TIMELINE_TDR_RELEASE: "EVENT_REPORT_TIMELINE_TDR_RELEASE",
  EVENT_REPORT_TIMELINE_CONNECT_AGENT_ASSIGNED: "EVENT_REPORT_TIMELINE_CONNECT_AGENT_ASSIGNED",
  EVENT_REPORT_TIMELINE_CONNECT_CONTACT: "EVENT_REPORT_TIMELINE_CONNECT_CONTACT",
  EVENT_REPORT_TIMELINE_SOURCE_EVENTS: "EVENT_REPORT_TIMELINE_SOURCE_EVENTS",
  EVENT_REPORT_TIMELINE_START_TIME: "EVENT_REPORT_TIMELINE_START_TIME",
  EVENT_REPORT_TIMELINE_OBSERVED_ACTIVITY: "EVENT_REPORT_TIMELINE_OBSERVED_ACTIVITY",
  EVENT_REPORT_TIMELINE_OBSERVED_ACTIVITY_INFO: "EVENT_REPORT_TIMELINE_OBSERVED_ACTIVITY_INFO",
  EVENT_REPORT_TIMELINE_GATE_OBSERVED_ACTIVITY_INFO:
    "EVENT_REPORT_TIMELINE_GATE_OBSERVED_ACTIVITY_INFO",
  EVENT_REPORT_TIMELINE_DERIVED_INTERVALS: "EVENT_REPORT_TIMELINE_DERIVED_INTERVALS",
  EVENT_REPORT_TIMELINE_LEGEND: "EVENT_REPORT_TIMELINE_LEGEND",
  EVENT_REPORT_TIMELINE_GATE_OPERATION_START: "EVENT_REPORT_TIMELINE_GATE_OPERATION_START",
  EVENT_REPORT_TIMELINE_GATE_OPERATION_COMPLETED: "EVENT_REPORT_TIMELINE_GATE_OPERATION_COMPLETED",
  EVENT_REPORT_TIMELINE_SELECTED_EVENT: "EVENT_REPORT_TIMELINE_SELECTED_EVENT",
  EVENT_REPORT_TIMELINE_CHART_ARIA: "EVENT_REPORT_TIMELINE_CHART_ARIA",
  EVENT_REPORT_TIMELINE_EVENT_ARIA: "EVENT_REPORT_TIMELINE_EVENT_ARIA",
  EVENT_REPORT_TIMELINE_EVENT_HISTORY_SOURCE: "EVENT_REPORT_TIMELINE_EVENT_HISTORY_SOURCE",
  EVENT_REPORT_TIMELINE_GATE_WORKFLOW_SOURCE: "EVENT_REPORT_TIMELINE_GATE_WORKFLOW_SOURCE",
  EVENT_REPORT_TIMELINE_GATE_SENSOR_SOURCE: "EVENT_REPORT_TIMELINE_GATE_SENSOR_SOURCE",
  EVENT_REPORT_TIMELINE_SOURCE: "EVENT_REPORT_TIMELINE_SOURCE",
  EVENT_REPORT_TIMELINE_SOURCE_RECORD_ID: "EVENT_REPORT_TIMELINE_SOURCE_RECORD_ID",
  EVENT_REPORT_TIMELINE_END_TIME: "EVENT_REPORT_TIMELINE_END_TIME",
  EVENT_REPORT_GENERAL_EQUIPMENT_INFORMATION: "EVENT_REPORT_GENERAL_EQUIPMENT_INFORMATION",
  EVENT_REPORT_EQUIPMENT_ID: "EVENT_REPORT_EQUIPMENT_ID",
  EVENT_REPORT_EQUIPMENT_NUMBER: "EVENT_REPORT_EQUIPMENT_NUMBER",
  EVENT_REPORT_OWNER_CODE: "EVENT_REPORT_OWNER_CODE",
  EVENT_REPORT_CHECK_IN_LOCATION: "EVENT_REPORT_CHECK_IN_LOCATION",
  EVENT_REPORT_LOCATION_CODE: "EVENT_REPORT_LOCATION_CODE",
  EVENT_REPORT_LOCATION_TYPE: "EVENT_REPORT_LOCATION_TYPE",
  EVENT_REPORT_LOCATION_SOURCE: "EVENT_REPORT_LOCATION_SOURCE",
  EVENT_REPORT_LICENSE_PLATE_DETAILS: "EVENT_REPORT_LICENSE_PLATE_DETAILS",
  EVENT_REPORT_REGISTRATION_IDENTIFIER: "EVENT_REPORT_REGISTRATION_IDENTIFIER",
  EVENT_REPORT_COUNTRY_CODE: "EVENT_REPORT_COUNTRY_CODE",
  EVENT_REPORT_SUBNATIONAL_ENTITY: "EVENT_REPORT_SUBNATIONAL_ENTITY",
  EVENT_REPORT_LOAD_IDENTIFIER: "EVENT_REPORT_LOAD_IDENTIFIER",
  EVENT_REPORT_DETAIL_LOAD_TYPE: "EVENT_REPORT_DETAIL_LOAD_TYPE",
  EVENT_REPORT_REJECTION_REASON: "EVENT_REPORT_REJECTION_REASON",
  EVENT_REPORT_REJECTION_TYPE: "EVENT_REPORT_REJECTION_TYPE",
  EVENT_REPORT_SEAL_NUMBER: "EVENT_REPORT_SEAL_NUMBER",
  EVENT_REPORT_SEAL_SOURCE: "EVENT_REPORT_SEAL_SOURCE",
  EVENT_REPORT_SEAL_CONDITION: "EVENT_REPORT_SEAL_CONDITION",
  EVENT_REPORT_SEAL_VERIFICATION_STATUS: "EVENT_REPORT_SEAL_VERIFICATION_STATUS",
  EVENT_REPORT_BOL_VERIFICATION_STATUS: "EVENT_REPORT_BOL_VERIFICATION_STATUS",
  EVENT_REPORT_BLOCKING_SEAL_VERIFICATION_STATUS: "EVENT_REPORT_BLOCKING_SEAL_VERIFICATION_STATUS",
  EVENT_REPORT_LOAD_HEADING: "EVENT_REPORT_LOAD_HEADING",
  EVENT_REPORT_SEAL_HEADING: "EVENT_REPORT_SEAL_HEADING",
  EVENT_REPORT_AGENT_DETAILS: "EVENT_REPORT_AGENT_DETAILS",
  EVENT_REPORT_AGENT_TAB: "EVENT_REPORT_AGENT_TAB",
  EVENT_REPORT_ESCALATION_CONNECT_CONTACT_ID: "EVENT_REPORT_ESCALATION_CONNECT_CONTACT_ID",
  EVENT_REPORT_AGENT_PLATFORM: "EVENT_REPORT_AGENT_PLATFORM",
  EVENT_REPORT_AGENT_ID: "EVENT_REPORT_AGENT_ID",
  EVENT_REPORT_IS_READ_ONLY_AGENT: "EVENT_REPORT_IS_READ_ONLY_AGENT",
  EVENT_REPORT_AGENT_ASSIGNMENT_STATUS: "EVENT_REPORT_AGENT_ASSIGNMENT_STATUS",
  EVENT_REPORT_CONNECT_CONTACT_DETAILS: "EVENT_REPORT_CONNECT_CONTACT_DETAILS",
  EVENT_REPORT_DETAIL_CONNECT_CONTACT_ID: "EVENT_REPORT_DETAIL_CONNECT_CONTACT_ID",
  EVENT_REPORT_AGENT_USER_NAME: "EVENT_REPORT_AGENT_USER_NAME",
  EVENT_REPORT_QUEUE_DURATION: "EVENT_REPORT_QUEUE_DURATION",
  EVENT_REPORT_AFTER_CONTACT_WORK_DURATION: "EVENT_REPORT_AFTER_CONTACT_WORK_DURATION",
  EVENT_REPORT_DISCONNECT_REASON: "EVENT_REPORT_DISCONNECT_REASON",
  EVENT_REPORT_SECONDS: "EVENT_REPORT_SECONDS",
  EVENT_REPORT_COMPLETION_STATUS: "EVENT_REPORT_COMPLETION_STATUS",
  EVENT_REPORT_END_STATUS_DETAILS: "EVENT_REPORT_END_STATUS_DETAILS",
  EVENT_REPORT_FINAL_STATUS: "EVENT_REPORT_FINAL_STATUS",
  EVENT_REPORT_REJECTION_STATUS: "EVENT_REPORT_REJECTION_STATUS",
  EVENT_REPORT_YES: "EVENT_REPORT_YES",
  EVENT_REPORT_NO: "EVENT_REPORT_NO",
  EVENT_REPORT_TIMELINE_OPEN_INTERVAL: "EVENT_REPORT_TIMELINE_OPEN_INTERVAL",
  EVENT_REPORT_TIMELINE_CLOSED_INTERVAL: "EVENT_REPORT_TIMELINE_CLOSED_INTERVAL",
  EVENT_REPORT_TIMELINE_SEQUENCE_ARIA: "EVENT_REPORT_TIMELINE_SEQUENCE_ARIA",
  EVENT_REPORT_TIMELINE_EVENT_META: "EVENT_REPORT_TIMELINE_EVENT_META",
  EVENT_REPORT_TIMELINE_GAP: "EVENT_REPORT_TIMELINE_GAP",
  EVENT_REPORT_TIMELINE_PROVENANCE: "EVENT_REPORT_TIMELINE_PROVENANCE",
  EVENT_REPORT_TIMELINE_NO_END_EVENT: "EVENT_REPORT_TIMELINE_NO_END_EVENT",
  EVENT_REPORT_TIMELINE_LOADING: "EVENT_REPORT_TIMELINE_LOADING",
  EVENT_REPORT_TIMELINE_NO_SUBJECT_EVENTS: "EVENT_REPORT_TIMELINE_NO_SUBJECT_EVENTS",
  EVENT_REPORT_TIMELINE_RESOLUTION_INCOMPLETE: "EVENT_REPORT_TIMELINE_RESOLUTION_INCOMPLETE",
  EVENT_REPORT_TIMELINE_CHOOSE_VISIT: "EVENT_REPORT_TIMELINE_CHOOSE_VISIT",
  EVENT_REPORT_TIMELINE_CHOOSE_VISIT_SUMMARY: "EVENT_REPORT_TIMELINE_CHOOSE_VISIT_SUMMARY",
  EVENT_REPORT_TIMELINE_CHOOSE_EVENT_VISIT_SUMMARY:
    "EVENT_REPORT_TIMELINE_CHOOSE_EVENT_VISIT_SUMMARY",
  EVENT_REPORT_TIMELINE_CHOOSE_GATE_OPERATION: "EVENT_REPORT_TIMELINE_CHOOSE_GATE_OPERATION",
  EVENT_REPORT_TIMELINE_CHOOSE_GATE_OPERATION_SUMMARY:
    "EVENT_REPORT_TIMELINE_CHOOSE_GATE_OPERATION_SUMMARY",
  EVENT_REPORT_TIMELINE_UNATTRIBUTED_ROWS: "EVENT_REPORT_TIMELINE_UNATTRIBUTED_ROWS",
  EVENT_REPORT_TIMELINE_VISIT_ID: "EVENT_REPORT_TIMELINE_VISIT_ID",
  EVENT_REPORT_TIMELINE_CANDIDATE_META: "EVENT_REPORT_TIMELINE_CANDIDATE_META",
  EVENT_REPORT_TIMELINE_CANDIDATE_VEHICLE: "EVENT_REPORT_TIMELINE_CANDIDATE_VEHICLE",
  EVENT_REPORT_TIMELINE_UNKNOWN_YARD: "EVENT_REPORT_TIMELINE_UNKNOWN_YARD",
  EVENT_REPORT_TIMELINE_EVENT_TITLE: "EVENT_REPORT_TIMELINE_EVENT_TITLE",
  EVENT_REPORT_TIMELINE_GATE_OPERATION_TITLE: "EVENT_REPORT_TIMELINE_GATE_OPERATION_TITLE",
  EVENT_REPORT_TIMELINE_VISIT_TITLE: "EVENT_REPORT_TIMELINE_VISIT_TITLE",
  EVENT_REPORT_TIMELINE_EXACT_SUBJECT: "EVENT_REPORT_TIMELINE_EXACT_SUBJECT",
  EVENT_REPORT_TIMELINE_SUBJECT_SUMMARY: "EVENT_REPORT_TIMELINE_SUBJECT_SUMMARY",
  EVENT_REPORT_TIMELINE_BACK_TO_CHOOSER: "EVENT_REPORT_TIMELINE_BACK_TO_CHOOSER",
  EVENT_REPORT_TIMELINE_INCOMPLETE: "EVENT_REPORT_TIMELINE_INCOMPLETE",
  EVENT_REPORT_TIMELINE_GATE_INCOMPLETE: "EVENT_REPORT_TIMELINE_GATE_INCOMPLETE",
  EVENT_REPORT_TIMELINE_FILTER_CAVEAT: "EVENT_REPORT_TIMELINE_FILTER_CAVEAT",

  // Equipment/vehicle type labels — app-wide (RYC, RYTE/RAD, and any
  // future surface). One canonical set; do not re-declare per feature.
  VEHICLE_TYPE_TRAILER: "VEHICLE_TYPE_TRAILER",
  VEHICLE_TYPE_TRAILER_SKIRTED: "VEHICLE_TYPE_TRAILER_SKIRTED",
  VEHICLE_TYPE_TRAILER_PUP: "VEHICLE_TYPE_TRAILER_PUP",
  VEHICLE_TYPE_TRAILER_PUP_SKIRT: "VEHICLE_TYPE_TRAILER_PUP_SKIRT",
  VEHICLE_TYPE_TRAILER_PUP_INTERMODAL: "VEHICLE_TYPE_TRAILER_PUP_INTERMODAL",
  VEHICLE_TYPE_TRAILER_INTERMODAL: "VEHICLE_TYPE_TRAILER_INTERMODAL",
  VEHICLE_TYPE_TRAILER_REFRIGERATED: "VEHICLE_TYPE_TRAILER_REFRIGERATED",
  VEHICLE_TYPE_TRAILER_CAPTIVE_BEAM: "VEHICLE_TYPE_TRAILER_CAPTIVE_BEAM",
  VEHICLE_TYPE_TRAILER_CAPTIVE_BEAM_SKIRTED: "VEHICLE_TYPE_TRAILER_CAPTIVE_BEAM_SKIRTED",
  VEHICLE_TYPE_TRAILER_BOX_TRUCK: "VEHICLE_TYPE_TRAILER_BOX_TRUCK",
  VEHICLE_TYPE_TRAILER_DOUBLE: "VEHICLE_TYPE_TRAILER_DOUBLE",
  VEHICLE_TYPE_TRAILER_FLATBED: "VEHICLE_TYPE_TRAILER_FLATBED",
  VEHICLE_TYPE_TRAILER_SOFT: "VEHICLE_TYPE_TRAILER_SOFT",
  VEHICLE_TYPE_SWAP_BODY: "VEHICLE_TYPE_SWAP_BODY",
  VEHICLE_TYPE_BOX_TRUCK: "VEHICLE_TYPE_BOX_TRUCK",
  VEHICLE_TYPE_BOX_TRUCK_2T: "VEHICLE_TYPE_BOX_TRUCK_2T",
  VEHICLE_TYPE_BOX_TRUCK_4T: "VEHICLE_TYPE_BOX_TRUCK_4T",
  VEHICLE_TYPE_BOX_TRUCK_10T: "VEHICLE_TYPE_BOX_TRUCK_10T",
  VEHICLE_TYPE_SPRINTER_VAN: "VEHICLE_TYPE_SPRINTER_VAN",
  VEHICLE_TYPE_BOX_SPRINTER_VAN: "VEHICLE_TYPE_BOX_SPRINTER_VAN",
  VEHICLE_TYPE_TRACTOR: "VEHICLE_TYPE_TRACTOR",
  VEHICLE_TYPE_TRACTOR_FLATBED: "VEHICLE_TYPE_TRACTOR_FLATBED",
  VEHICLE_TYPE_HOSTLER: "VEHICLE_TYPE_HOSTLER",
  VEHICLE_TYPE_CAR: "VEHICLE_TYPE_CAR",
  VEHICLE_TYPE_MOTORCYCLE: "VEHICLE_TYPE_MOTORCYCLE",
  VEHICLE_TYPE_THREE_WHEELER: "VEHICLE_TYPE_THREE_WHEELER",
  VEHICLE_TYPE_PERSON: "VEHICLE_TYPE_PERSON",
  VEHICLE_TYPE_AIRPLANE: "VEHICLE_TYPE_AIRPLANE",
  VEHICLE_TYPE_DOLLY: "VEHICLE_TYPE_DOLLY",
};
